import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useState } from "react"
import { profileActions } from "src/features/profile"
import { MeUser } from "src/features/profile/models"
import { useAppDispatch } from "./hooks"
import { useFetchIdp } from "./useFetchIdp"

const VITE_MBLS_DISPATCH_URL = import.meta.env.VITE_MBLS_DISPATCH_URL

export const useMe = () => {
  const { logout } = useAuth0()
  const fetchIdp = useFetchIdp()

  const dispatch = useAppDispatch()

  const [isLoading, setIsLoading] = useState(false)

  const fetchUser = useCallback(async () => {
    try {
      setIsLoading(true)
      const response = await fetchIdp(`${VITE_MBLS_DISPATCH_URL}me`)
      if (!response.ok) {
        throw new Error("Failed to fetch user data")
      }
      const json: { data: MeUser; impersonateMessage: string | undefined } =
        await response.json()

      dispatch(profileActions.setMe(json.data))
      dispatch(profileActions.setImpersonateMessage(json.impersonateMessage))
    } catch (err) {
      console.error("Error fetching user data:", err)
      dispatch(profileActions.clearMe())
      logout({ logoutParams: { returnTo: window.location.origin } })
    } finally {
      setIsLoading(false)
    }
  }, [dispatch, fetchIdp, logout])

  return { fetchMe: fetchUser, isLoading }
}
